import { LoadingContainer } from 'components/loadingContainer'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { Navigate, Outlet } from 'react-router-dom'
import { UserRole } from 'types/Organization'

export const ProtectedRouteOA = () => {
    const { currentAccount, isLoadingCurrentAccount } = useCurrentAccount()

    return (
        <LoadingContainer isLoading={isLoadingCurrentAccount} error={null}>
            {!isLoadingCurrentAccount && currentAccount && currentAccount.role === UserRole.orgAdmin ? (
                <Outlet />
            ) : (
                <Navigate to="/login" />
            )}
        </LoadingContainer>
    )
}
